import React, { useEffect, useState } from "react";
import { globals } from "../globals";

function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetch(`${globals.homepageUrl}/php/get-orders.php`)
      .then((res) => res.json())
      .then((data) => {
        setOrders(data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const toggleOrder = (id) => {
    setSelectedOrders((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const confermaOrdini = async () => {
    const ordiniSelezionati = orders.filter((o) => selectedOrders[o.id]);

    for (const ordine of ordiniSelezionati) {
      try {
        const response = await fetch(`${globals.homepageUrl}/php/order-confirm.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: ordine.id,
            email: ordine.email,
            totale: ordine.totale,
            dettagli: ordine.dettagli.map((item) => ({
              src: item.src,
              filename: item.filename,
            })),
          }),
        });

        const text = await response.text();
        let result;

        try {
          result = JSON.parse(text);
        } catch (e) {
          console.error(`Ordine ${ordine.id} - Risposta non valida dal server:`, text);
          continue;
        }

        if (result.success) {
          //console.log(`Ordine ${ordine.id} confermato!`);
        } else {
          console.error(`Errore ordine ${ordine.id}:`, result.error);
        }
      } catch (error) {
        console.error(`Errore rete ordine ${ordine.id}:`, error);
      }
    }

    // Refresh
    fetch(`${globals.homepageUrl}/php/get-orders.php`)
      .then((res) => res.json())
      .then((data) => {
        setOrders(data);
        setSelectedOrders({});
        window.dispatchEvent(new Event("ordersUpdated"));
      });
  };

  if (loading) return <p>Caricamento ordini...</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h1>Gestione Ordini</h1>
      {message && <p><strong>{message}</strong></p>}
      <button onClick={confermaOrdini} style={{ marginBottom: "10px" ,width:"200px",height:"40px", border:"1px solid",borderRadius:"6px",fontSize:"14px"}}>
        Conferma Ordini Selezionati
      </button>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "2px solid #999"}}>
            <th></th>
            <th>ID</th>
            <th>Email</th>
            <th>Totale</th>
            <th>Stato</th>
            <th>IP</th>
            <th>Data</th>
            <th>Dettagli</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr
              key={order.id}
              style={{
                borderBottom: "2px solid #ddd",
                backgroundColor: order.stato === "in attesa" ? "#ffe6e6" : "transparent",
                color: order.stato === "in attesa" ? "red" : "inherit",
                fontWeight: order.stato === "in attesa" ? "bold" : "normal"
              }}
            >
              <td >
                <input
                  type="checkbox"
                  checked={!!selectedOrders[order.id]}
                  onChange={() => toggleOrder(order.id)}
                />
              </td>
              <td>{order.id}</td>
              <td>{order.email}</td>
              <td>€{order.totale}</td>
              <td
                style={{
                  color: order.stato === "in attesa" ? "red" : "inherit",
                  fontWeight: order.stato === "in attesa" ? "bold" : "normal"
                }}
              >
                {order.stato}
              </td>
              <td>{order.ip_address}</td>
              <td >{order.data_ordine}</td>
              <td style={{ maxWidth: "250px", wordBreak: "break-word" }}>
                  {order.dettagli.map((file, i) => (
                    <div
                      key={i}
                      style={{
                        marginBottom: "0px",
                        padding: "0px",
                        borderBottom: "1px solid #eee",
                        fontSize: "14px",
                        lineHeight: "1.4",
                        color: "#333",
                      }}
                    >
                      {file.filename} - {file.alt} - €{file.price}
                    </div>
                  ))}
                </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminOrders;
